import React, { useState } from 'react'
import TopCmlCard from './components/TopCmlCard/TopCmlCard'
import { Divider, Tooltip, Button, Loading, Text } from '@sede-enterprise/shell-ds-react-framework'
import FilterModal from '../../components/FilterModal/FilterModal'
import { Filter } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components'
import './Home.css'
import useFetchTopCmls from './hooks/useFetchTopCmls'
import SensorDataList from './components/SensorDataList/SensorDataList'
import RemanentLifeChart from './components/RemanentLifeChart/RemanentLifeChart'
import { DocumentTitle } from '../../components/DocumentTitle/DocumentTitle'
import useLogReport from '../../util/hooks/useLogReport'

const Home = () => {

    // Log report for the page
    useLogReport('HOME');

    // Settting the filter for the sensor data
    const [sensorFilter, setSensorFilter] = useState(sessionStorage.getItem("sensorApplyfilter") || `sensor.excludeFromUi = 0`);


    // Handling the sensor filter change
    const handleSensorFilterChange = (appliedFilter, filterFormValues) => {
        if (appliedFilter) {
            sessionStorage.setItem('sensorApplyfilter', appliedFilter);
            sessionStorage.setItem('sensorFilterValues', JSON.stringify(filterFormValues));
        } else {
            sessionStorage.removeItem('sensorApplyfilter');
            sessionStorage.removeItem('sensorFilterValues');
        }
        setSensorFilter(appliedFilter);
    }

    // //Clearing the sensor filter
    const clearSensorFilter = () => {
        sessionStorage.removeItem('sensorApplyfilter');
        sessionStorage.removeItem('sensorFilterValues');
        setSensorFilter(`sensor.excludeFromUi = 0`);
    }

    // Filter Modal
    const [open, setOpen] = useState(false);
    const handleFilterModalClose = () => {
        setOpen(false);
    }

    // Fetching the top CMLs
    const { data: topCmlsData, error: topCmlError, loading: topCmlLoading } = useFetchTopCmls(sensorFilter);
    return <>
        <DocumentTitle title='CARMA' />
        <div className='parent-container' id='home-id-1'>
            <div className='content-container' id='home-id-2'>
                <div className='content-header' id='home-id-3'>
                    <h2 id='home-id-4'>CMLs with Highest Corrosion Rate</h2>
                    <Tooltip id='home-id-5' overlay={<span id='home-id-6'>Filter Options</span>}
                        placement='bottom'
                        trigger={<Button data-testid="filter-btn" id='home-id-7' iconOnly icon={<Filter id='home-id-8' />}
                            variant='filled' onClick={() => setOpen(true)} />} />
                </div>
                <div className='content-body' id='home-id-9'>
                    <div className='top-cmls-section' id='home-id-10'>
                        
                        {Array.isArray(topCmlsData) && topCmlsData.length > 0 && (
                        <div className='top-three-cmls' id='home-id-15'>
                            {topCmlsData.map(cml => (
                            <TopCmlCard key={cml.name} cmlData={cml} id='home-id-16' />
                            ))}
                        </div>
                        )}

                        { <RemanentLifeChart filter={sensorFilter} id='home-id-17' /> }
                    </div>
                </div >
            </div >
        </div>
        <br id='home-id-18' />
        <br id='home-id-19' />
        <Divider id='home-id-20' />
        <SensorDataList filter={sensorFilter} id='home-id-21' />
        <FilterModal open={open} onClose={handleFilterModalClose}
            handleFilterChange={handleSensorFilterChange}
            handleFilterClear={clearSensorFilter}
            filterKey="sensorFilterValues"
            id='home-id-22'
        />
    </>

}

export default Home